<div class="info-container">
  <div class="info-text">
    <div class="d-flex justify-content-between w-100 align-items-center">
      <h3>{{ 'view_translations.' + ( isBannerComponent ? 'configuration_for_banner' : 'configuration_for_product' ) | translate }}</h3>
      <div class="campaign-name" [ngClass]="{'step2' : step == 2}">
        <h4 class="modal-name">{{ currentCampaignName }}</h4>
      </div>
    </div>
    <h1>{{ isBannerComponent ? selectedBannerSize : selectedConfigData?.name }}</h1>
  </div>
  <div class="info-img">
    <img
      *ngIf="isBannerComponent; else productsImage"
      src="{{ selectedConfigData?.img }}"
      default="{{ defaultImage }}"
      [ngStyle]="{'width.px': selectedConfigData?.width, 'height.px': selectedConfigData?.height}" />
    <ng-template #productsImage>
      <img class="products-img" src="{{ selectedConfigData?.product_img }}" default="{{ defaultImage }}" />
    </ng-template>
  </div>
</div>
